export interface PerfilPresente {
  /** Slug usado na URL (/presentes/:perfilSlug) */
  slug: string;
  /** Tag gravada nos produtos (filtro do catálogo) */
  tag: string;
  label: string;
  emoji: string;
  descricao: string;
}

export const PERFIS_PRESENTES: PerfilPresente[] = [
  {
    slug: 'namorada',
    tag: 'perfil-namorada',
    label: 'Namorada',
    emoji: '💝',
    descricao: 'Presentes para surpreender e encantar',
  },
  {
    slug: 'namorado',
    tag: 'perfil-namorado',
    label: 'Namorado',
    emoji: '🕶️',
    descricao: 'Do tech ao churrasco, acerto garantido',
  },
  {
    slug: 'mae',
    tag: 'perfil-mae',
    label: 'Mãe',
    emoji: '🌷',
    descricao: 'Carinho em forma de presente',
  },
  {
    slug: 'pai',
    tag: 'perfil-pai',
    label: 'Pai',
    emoji: '🛠️',
    descricao: 'Para o paizão que merece',
  },
  {
    slug: 'amiga',
    tag: 'perfil-amiga',
    label: 'Amiga',
    emoji: '✨',
    descricao: 'Mimos para a melhor amiga',
  },
  {
    slug: 'amigo',
    tag: 'perfil-amigo',
    label: 'Amigo',
    emoji: '🍻',
    descricao: 'Para o parceiro de todas as horas',
  },
  {
    slug: 'beleza',
    tag: 'perfil-beleza',
    label: 'Beleza',
    emoji: '💄',
    descricao: 'Maquiagem, skincare, cabelo e perfumaria',
  },
  {
    slug: 'meninas',
    tag: 'perfil-meninas',
    label: 'Meninas (6-15)',
    emoji: '🎀',
    descricao: 'Diversão e criatividade para elas',
  },
  {
    slug: 'meninos',
    tag: 'perfil-meninos',
    label: 'Meninos (6-15)',
    emoji: '🚀',
    descricao: 'Aventura e adrenalina para eles',
  },
  {
    slug: 'adolescentes',
    tag: 'perfil-adolescentes',
    label: 'Adolescentes',
    emoji: '🎧',
    descricao: 'Tech, games e estilo',
  },
  {
    slug: 'bebes',
    tag: 'perfil-bebes',
    label: 'Bebês',
    emoji: '👶',
    descricao: 'Tudo para a chegada do bebê',
  },
  {
    slug: 'casa-nova',
    tag: 'perfil-casa-nova',
    label: 'Casa Nova',
    emoji: '🏡',
    descricao: 'Para montar o lar dos sonhos',
  },
  {
    slug: 'casal',
    tag: 'perfil-casal',
    label: 'Casal',
    emoji: '💍',
    descricao: 'Presentes para a vida a dois',
  },
  {
    slug: 'avos',
    tag: 'perfil-avos',
    label: 'Avós',
    emoji: '🧶',
    descricao: 'Conforto e carinho para eles',
  },
  {
    slug: 'gamer',
    tag: 'perfil-gamer',
    label: 'Gamer',
    emoji: '🎮',
    descricao: 'Para quem vive no joystick',
  },
  {
    slug: 'fitness',
    tag: 'perfil-fitness',
    label: 'Fitness',
    emoji: '💪',
    descricao: 'Para quem não pula o treino',
  },
  {
    slug: 'pet',
    tag: 'perfil-pet',
    label: 'Pet Lovers',
    emoji: '🐶',
    descricao: 'Para o pet e quem ama um',
  },
  {
    slug: 'viagem',
    tag: 'perfil-viagem',
    label: 'Viagem',
    emoji: '✈️',
    descricao: 'Para quem vive de mala pronta',
  },
];

export const obterPerfilPorSlug = (slug?: string | null): PerfilPresente | null =>
  PERFIS_PRESENTES.find((perfil) => perfil.slug === slug) ?? null;
